function AppRun($document, $rootScope, $state, localService, navigationService, storageKeys, states, appName) {
  'ngInject';

  // NOTE navigationService is purely included for initialization.

  // access to $state from templates
  $rootScope.$state = $state;

  // record old state and change page title based on state
  $rootScope.$on('$stateChangeStart', (event, to, toParams, from, fromParams) => {
    // save the previous state in a rootScope variable so that it's accessible from everywhere
    $rootScope.previousState = from;
    $rootScope.previousParams = fromParams;
    if (from.sticky !== false) {
      $rootScope.previousActiveElement = $document[0].activeElement;
    }
    $rootScope.setPageTitle(to.title);
    const region = localService.get(storageKeys.selectedRegion);
    if (!region && to.name && to.name !== states.regionSelectionLanding) {
      // no default region detected. go to region selection page
      console.log('## APP ## Redirect to region selection');
      if (from.name !== states.regionSelectionLanding) {
        event.preventDefault();
        $state.go(states.regionSelectionLanding, {}, { location: 'replace' });
      }
    }
  });
  // Helper method for setting the page's title
  $rootScope.setPageTitle = (title) => {
    $rootScope.pageTitle = '';
    if (title) {
      $rootScope.pageTitle += title.en;
      $rootScope.pageTitle += ' \u2014 ';
    }
    $rootScope.pageTitle += appName;
  };
}

export default AppRun;



/** WEBPACK FOOTER **
 ** ./client/app/app.run.js
 **/